"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMeterReadingValidationlimitsV1 = exports.getHouseTypeExpectedConsumptionV1 = exports.getAddressExpectedConsumptionV1 = exports.getDeviationReasonsV1 = exports.getHistoricConsumptionV1 = exports.getBudgetBillingAdviceV3 = exports.getBudgetBillingAdviceV2 = exports.getBudgetBillAdvicesV1 = exports.getMeterReadingHistoryV2 = exports.getMeterReadingHistoryV1 = exports.getMeteringMeterType = exports.getTotalActualConsumptionV1 = exports.getMeteringInstallationDetailsV2 = exports.getMeteringConsentsV3 = void 0;
/**
 * Returns a list of applicable metering consents. Only contains smart metering consents when the customer has at least one smart meter.
 * @param data The data for the request.
 * @param data.accountId The business partner id of the account to lookup the contract groups
 * @returns GetConsentsResponse OK
 * @throws ApiError
 */
const getMeteringConsentsV3 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/metering/consents/v3',
        query: {
            account_id: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getMeteringConsentsV3 = getMeteringConsentsV3;
/**
 * Returns a list of applicable installation details.
 * @param data The data for the request.
 * @param data.accountId An unique number that represents an user
 * @param data.supplyAddressId The supply address identifier key
 * @param data.keyDate Customer's last active date or Current date
 * @param data.contractGroupId The contract identifier key
 * @param data.connectEan The EAN Code of the installation
 * @returns GetInstallationDetailsResponse OK
 * @throws ApiError
 */
const getMeteringInstallationDetailsV2 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/metering/installationdetails/v2',
        query: {
            account_id: data.accountId,
            key_date: data.keyDate,
            supply_address_id: data.supplyAddressId,
            contract_group_id: data.contractGroupId,
            connect_ean: data.connectEan
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getMeteringInstallationDetailsV2 = getMeteringInstallationDetailsV2;
/**
 * Returns total annual consumption for all connections on a supply address.
 * @param data The data for the request.
 * @param data.accountId An unique number that represents an user
 * @param data.supplyAddressId The supply address identifier key
 * @returns GetTotalActualConsumptionResponse OK
 * @throws ApiError
 */
const getTotalActualConsumptionV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/metering/totalconsumption/v1',
        query: {
            account_id: data.accountId,
            supply_address_id: data.supplyAddressId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getTotalActualConsumptionV1 = getTotalActualConsumptionV1;
/**
 * Returns whether a supply address has a smart meter present
 * @param data The data for the request.
 * @param data.accountId The business partner id of the account
 * @param data.supplyAddressId The supply address identifier key
 * @returns GetMeterTypeResponse OK
 * @throws ApiError
 */
const getMeteringMeterType = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/metering/metertype/v1',
        query: {
            account_id: data.accountId,
            supply_address_id: data.supplyAddressId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getMeteringMeterType = getMeteringMeterType;
/**
 * Returns the meter reading history details for the specified installations
 * @param data The data for the request.
 * @param data.connectEan The "Europees Artikel Nummer" (ean) of the connection
 * @param data.accountId The account identifier
 * @param data.startDate The start date for the date range filter
 * @param data.endDate The end date for the date range filter
 * @param data.onlyLastMeterReading Indicate if only the latest MeterReadings in the given date range is required
 * @param data.readingProcessType Process type of the MeterReadings
 * @param data.readingMethod Code of origin and indication of measuring method
 * @param data.meteringDirection The direction of the meter reading
 * @param data.tariffType Tariff type of the meter reading
 * @returns GetMeterReadingHistoryResponse OK
 * @throws ApiError
 */
const getMeterReadingHistoryV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/metering/meterreadinghistory/v1',
        query: {
            connect_ean: data.connectEan,
            account_id: data.accountId,
            start_date: data.startDate,
            end_date: data.endDate,
            only_last_meter_reading: data.onlyLastMeterReading,
            reading_process_type: data.readingProcessType,
            reading_method: data.readingMethod,
            metering_direction: data.meteringDirection,
            tariff_type: data.tariffType
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getMeterReadingHistoryV1 = getMeterReadingHistoryV1;
/**
 * Returns the meter reading history details for the specified installations
 * @param data The data for the request.
 * @param data.eans The "Europees Artikel Nummer" (ean) of the connection
 * @param data.accountId The account identifier
 * @param data.startDate The start date for the date range filter
 * @param data.endDate The end date for the date range filter
 * @param data.lastMeterReadingOnly Indicate if only the latest MeterReadings in the given date range is required
 * @param data.readingProcessType Process type of the MeterReadings
 * @param data.readingMethod Code of origin and indication of measuring method
 * @param data.meteringDirection The direction of the meter reading
 * @param data.tariffType Tariff type of the meter reading
 * @returns GetMeterReadingHistoryResponseV2 OK
 * @throws ApiError
 */
const getMeterReadingHistoryV2 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/metering/meterreadinghistory/v2',
        query: {
            eans: data.eans,
            accountId: data.accountId,
            startDate: data.startDate,
            endDate: data.endDate,
            lastMeterReadingOnly: data.lastMeterReadingOnly,
            readingProcessType: data.readingProcessType,
            readingMethod: data.readingMethod,
            meteringDirection: data.meteringDirection,
            tariffType: data.tariffType
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getMeterReadingHistoryV2 = getMeterReadingHistoryV2;
/**
 * This API enables the customer to have advices on their budget bill, based on their historic and expected consumption and check whether it fits in the requirements to provide the advice.
 * @param data The data for the request.
 * @param data.accountId The business partner id of the account
 * @param data.supplyAddressId The supply address identifier key
 * @returns GetBudgetBillingAdvicesResponse OK
 * @throws ApiError
 */
const getBudgetBillAdvicesV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/metering/budgetbilladvices/v1',
        query: {
            account_id: data.accountId,
            supply_address_id: data.supplyAddressId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getBudgetBillAdvicesV1 = getBudgetBillAdvicesV1;
/**
 * This API enables the customer to have advice on their budget bill, based on their historic and expected consumption and check whether it fits in the requirements to provide the advice.
 * @param data The data for the request.
 * @param data.accountId The business partner id of the account
 * @param data.supplyAddressId The supply address identifier key
 * @returns GetBudgetBillingAdviceResponse OK
 * @throws ApiError
 */
const getBudgetBillingAdviceV2 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/metering/budgetbilladvice/v2',
        query: {
            account_id: data.accountId,
            supply_address_id: data.supplyAddressId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getBudgetBillingAdviceV2 = getBudgetBillingAdviceV2;
/**
 * This API enables the customer to have advice on their budget bill, based on their historic and expected consumption and check whether it fits in the requirements to provide the advice.
 * @param data The data for the request.
 * @param data.accountId The business partner id of the account
 * @param data.supplyAddressId The supply address identifier key
 * @returns GetBudgetBillingAdviceResponse OK
 * @throws ApiError
 */
const getBudgetBillingAdviceV3 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/metering/budgetbilladvice/v3',
        query: {
            account_id: data.accountId,
            supply_address_id: data.supplyAddressId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getBudgetBillingAdviceV3 = getBudgetBillingAdviceV3;
/**
 * This API allows to retrieve the historic consumption data for a given supplyaddress
 * @param data The data for the request.
 * @param data.accountId The business partner id of the account
 * @param data.supplyAddressId The supply address identifier key
 * @returns GetHistoricConsumptionResponse OK
 * @throws ApiError
 */
const getHistoricConsumptionV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/metering/historicconsumption/v1',
        query: {
            account_id: data.accountId,
            supply_address_id: data.supplyAddressId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getHistoricConsumptionV1 = getHistoricConsumptionV1;
/**
 * This API retrieves the deviation reasons based on account id and segment type
 * @param data The data for the request.
 * @param data.accountId The business partner id of the account
 * @param data.customerSegment Customer segment type
 * @returns GetDeviationReasonsResponse OK
 * @throws ApiError
 */
const getDeviationReasonsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/metering/deviationreasons/v1',
        query: {
            account_id: data.accountId,
            customer_segment: data.customerSegment
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getDeviationReasonsV1 = getDeviationReasonsV1;
/**
 * This API retrieves expected consumption for a given Address
 * @param data The data for the request.
 * @param data.postcode Valid Dutch Postal code with or without space
 * @param data.houseNumber House number of the address
 * @param data.vacancy indicate if the house is vacant
 * @param data.residents Number of people in the house
 * @param data.houseNumberExtension House number extension of the address
 * @returns GetExpectedConsumptionResponse OK
 * @throws ApiError
 */
const getAddressExpectedConsumptionV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/metering/address/expectedconsumption/v1',
        query: {
            postcode: data.postcode,
            house_number: data.houseNumber,
            vacancy: data.vacancy,
            residents: data.residents,
            house_number_extension: data.houseNumberExtension
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getAddressExpectedConsumptionV1 = getAddressExpectedConsumptionV1;
/**
 * This API retrieves expected consumption for a given houseType
 * @param data The data for the request.
 * @param data.houseType The type of house
 * @param data.residents The number of residents for a house
 * @returns GetExpectedConsumptionResponse OK
 * @throws ApiError
 */
const getHouseTypeExpectedConsumptionV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/metering/housetype/expectedconsumption/v1',
        query: {
            house_type: data.houseType,
            residents: data.residents
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getHouseTypeExpectedConsumptionV1 = getHouseTypeExpectedConsumptionV1;
/**
 * This service will returns the MeterReading validation limits details for a specific supply address
 * @param data The data for the request.
 * @param data.accountId The business partner id of the account
 * @param data.supplyAddressId The supply address identifier key
 * @returns GetMeterReadingValidationlimitsResponse OK
 * @throws ApiError
 */
const getMeterReadingValidationlimitsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/metering/meterreadingvalidationlimits/v1',
        query: {
            account_id: data.accountId,
            supply_address_id: data.supplyAddressId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getMeterReadingValidationlimitsV1 = getMeterReadingValidationlimitsV1;
